import { Money } from '../../../../types';

export const reduceMoney = <T>(
	items: T[],
	getItemPrice: (item: T) => Money | null | undefined,
	operation: (acc: Money, next: Money) => Money,
	initial: Money
): Money => {
	if (!items?.length) {
		return initial;
	}

	return items.reduce((acc, item) => {
		const price = getItemPrice(item);

		return price ? operation(acc, price) : acc;
	}, initial);
};
